<section id="projects" class="projects-section section-padding">
  <div class="container-wide">
    
    <!-- Section Header -->
    <div class="section-header">
      <span class="subtitle">FEATURED PORTFOLIO</span>
      <h2 class="title light">HOMES WE'RE PROUD TO BUILD</h2>
      <div class="gold-divider"></div>
      <p class="description light">
        Every home tells a story. Click any project to open its dedicated architectural showcase, video walkthrough, and high-resolution photo gallery.
      </p>
    </div>

    <!-- Filter Tabs -->
    <div class="filter-tabs">
      @for (cat of categories; track cat.id) {
        <button 
          class="tab-btn" 
          [class.active]="selectedCategory() === cat.id"
          (click)="setCategory(cat.id)">
          {{ cat.label }}
        </button>
      }
    </div>

    <!-- Projects Grid or Coming Soon Empty State -->
    @if (filteredProjects().length > 0) {
      <div class="projects-grid">
        @for (proj of filteredProjects(); track proj.id) {
          <div class="project-card" [routerLink]="['/project', proj.id]">
            <div class="proj-img-wrap">
              <img [src]="proj.image" [alt]="proj.title" (error)="onImgErr($event)">
              <div class="proj-overlay">
                <div class="proj-tag">{{ proj.categoryLabel }}</div>
                <h3 class="proj-title">{{ proj.title || proj.location }}</h3>
                @if (proj.title && proj.location) {
                  <p class="proj-location">{{ proj.location }}</p>
                }

                <!-- Multi-Dwelling Specs Box (e.g. Dwelling A & B) -->
                @if (proj.dwellings && proj.dwellings.length > 0) {
                  <div class="dwellings-specs-box">
                    @for (dwelling of proj.dwellings; track dwelling.name) {
                      <div class="dwelling-row">
                        @if (proj.dwellings.length > 1) {
                          <span class="dwelling-name">{{ dwelling.name }}</span>
                        }
                        <div class="dwelling-metrics">
                          @if (dwelling.bedrooms) {
                            <span class="metric-item" title="Bedrooms">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4v16"/><path d="M2 11h20"/><path d="M22 11v9"/><path d="M6 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M14 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M2 17h20"/></svg>
                              <span>{{ dwelling.bedrooms }} Bed</span>
                            </span>
                          }
                          @if (dwelling.bathrooms) {
                            <span class="metric-item" title="Bathrooms">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3zM4 12V7a2 2 0 0 1 2-2h3"/></svg>
                              <span>{{ dwelling.bathrooms }} Bath</span>
                            </span>
                          }
                          @if (dwelling.garageSpaces) {
                            <span class="metric-item" title="Garage Spaces">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H7.5a1 1 0 0 0-.8.4L4 11l-1.16.86A1 1 0 0 0 2 12.85V16h3"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="17.5" cy="16.5" r="2.5"/></svg>
                              <span>{{ dwelling.garageSpaces }} Garage</span>
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <!-- Quick Specs Icon Row -->
                  <div class="card-quick-specs">
                    @if (proj.bedrooms) {
                      <span class="spec-item" title="Bedrooms">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4v16"/><path d="M2 11h20"/><path d="M22 11v9"/><path d="M6 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M14 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M2 17h20"/></svg>
                        {{ proj.bedrooms }} Bedroom
                      </span>
                    }
                    @if (proj.bathrooms) {
                      <span class="spec-item" title="Bathrooms">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3zM4 12V7a2 2 0 0 1 2-2h3"/></svg>
                        {{ proj.bathrooms }} Bathroom
                      </span>
                    }
                    @if (proj.garageSpaces) {
                      <span class="spec-item" title="Garage">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H7.5a1 1 0 0 0-.8.4L4 11l-1.16.86A1 1 0 0 0 2 12.85V16h3"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="17.5" cy="16.5" r="2.5"/></svg>
                        {{ proj.garageSpaces }} Garage
                      </span>
                    }
                    @if (proj.landArea || proj.size) {
                      <span class="spec-item" title="Area">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="4 2"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/></svg>
                        {{ proj.landArea || proj.size }}
                      </span>
                    }
                    @if (proj.storeyType) {
                      <span class="spec-item storey-pill">{{ proj.storeyType }}</span>
                    }
                  </div>
                }

                @if (proj.description) {
                  <p class="proj-summary">{{ proj.description }}</p>
                }
                
                <div class="proj-hover-footer">
                  <span class="view-spec">VIEW FULL SHOWCASE & VIDEO &rarr;</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <!-- Coming Soon Empty State -->
      <div class="coming-soon-container">
        <div class="coming-soon-card">
          <span class="cs-badge">AMBITION BUILT PORTFOLIO</span>
          <h3 class="cs-title font-serif">COMING SOON</h3>
          <div class="cs-gold-divider"></div>
          <p class="cs-text">
            Bespoke architectural projects in this category are currently under development and will be featured shortly.
          </p>
          <button (click)="setCategory('all')" class="btn-gold">
            EXPLORE ALL PROJECTS &rarr;
          </button>
        </div>
      </div>
    }

  </div>
</section>
